var map = {
	"./CL23.jpg": 31234,
	"./CL23.webp": 956,
	"./CR23.png": 38872,
	"./CR23.webp": 28730,
	"./CV23.png": 3204,
	"./CV23.webp": 25398,
	"./EA16.png": 5665,
	"./EA16.webp": 64433,
	"./EI16.png": 90953,
	"./EI16.webp": 44489,
	"./EP24.png": 38599,
	"./EP24.webp": 47915,
	"./EX21.png": 13378,
	"./EX21.webp": 53660,
	"./HANG.png": 61930,
	"./HANG.webp": 56520,
	"./ING1.png": 86427,
	"./ING1.webp": 19531,
	"./ING2.png": 8096,
	"./ING2.webp": 83466,
	"./ING3.jpg": 87041,
	"./ING3.webp": 34645,
	"./INTE.png": 36702,
	"./INTE.webp": 35740,
	"./LV.png": 36492,
	"./LV.webp": 37378,
	"./LV23.png": 67733,
	"./LV23.webp": 71017,
	"./MSTE.png": 66903,
	"./MSTE.webp": 46887,
	"./MT23.png": 8780,
	"./MT23.webp": 90162,
	"./OU20.png": 63892,
	"./OU20.webp": 84862,
	"./PB21.png": 97095,
	"./PB21.webp": 13327,
	"./PBIA.png": 92414,
	"./PBIA.webp": 44284,
	"./PH18.png": 79233,
	"./PH18.webp": 77085,
	"./PNLB.png": 50014,
	"./PNLB.webp": 52560,
	"./PP16.png": 94791,
	"./PP16.webp": 29247,
	"./PP23.png": 79479,
	"./PP23.webp": 79639,
	"./PV24.png": 69582,
	"./PV24.webp": 49172,
	"./RC24.png": 35597,
	"./RC24.webp": 45621,
	"./SCRA.webp": 73079,
	"./WI10.png": 40629,
	"./WI10.webp": 59105,
	"./WO16.png": 34433,
	"./WO16.webp": 57325,
	"./WP21.png": 48660,
	"./WP21.webp": 9150,
	"./ZOOM.png": 90779,
	"./ZOOM.webp": 21267,
	"./combinacionCorrespondencia.jpg": 48381,
	"./default.png": 19571,
	"./default.webp": 78049,
	"./ejercicioComplementario.jpg": 3442,
	"./examenDiagnostico.png": 37800,
	"./examenDiagnostico.webp": 99260,
	"./formatoCondicional.jpg": 20259,
	"./macrosWord.jpg": 63705,
	"./rutaDeAprendizaje1.png": 11017,
	"./rutaDeAprendizaje1.webp": 83837,
	"./rutasAprendizaje.png": 39218,
	"./rutasAprendizaje.webp": 32932,
	"./scra.png": 66879,
	"./solver.jpg": 71627,
	"./tablaPibote.jpg": 70605,
	"./tablasWord.jpg": 41721,
	"./tablasdinamicas.jpg": 99358,
	"./transposicionDatos.jpg": 81373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81708;